import { useQuery } from '@tanstack/react-query';
import { ratesApi } from '../api';

export function useRates() {
  return useQuery({
    queryKey: ['rates'],
    queryFn: async () => {
      const response = await ratesApi.getRates();
      return response.data?.rates || [];
    },
  });
}
